import { mapActions, mapGetters } from 'vuex'
import { consultaViaCep } from '@/utils/utils'

export var regionMixin = {
  data() {
    return {
      alertCepIcon: '',
    }
  },
  computed: {
    ...mapGetters('regionModule', ['region', 'regionTax']),

    cmpRegion: {
      get: function () {
        return this.region ?? this.frmAddress
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },

    tooltipCepText() {
      return !this.region
        ? 'Informe seu CEP'
        : this.region.endereco.value +
            `, ${this.region.bairro.value.length > 0 ? 'Bairro' : ''}` +
            this.region.bairro.value +
            ', ' +
            this.region.cidade.value +
            ' / ' +
            this.region.estado.value
    },

    frmAddress() {
      const frm = {
        endereco: {
          label: 'Endereço',
          value: '',
          merge: true,
        },
        numero: {
          label: 'Número',
          value: '',
          merge: true,
        },
        complemento: {
          label: 'Complemento',
          value: '',
          merge: true,
        },
        bairro: {
          label: 'Bairro',
          value: '',
        },
        cidade: {
          label: 'Cidade',
          value: '',
          merge: true,
        },
        estado: {
          label: 'UF',
          value: '',
          merge: true,
        },
        cep: {
          label: 'CEP',
          value: '',
        },
      }

      return frm
    },
  },

  methods: {
    ...mapActions('regionModule', [
      'setRegion',
      'getRegionTax',
      'setRegionTax',
    ]),

    async consultaCep($event) {
      try {
        let param = $event.target.value ?? null
        if (!param || param.replace(/[^0-9]+/g, '').length <= 7) return

        // dados gestao
        const data = await consultaViaCep(param)

        param.replace(/[^0-9]+/g, '')

        if (data && data.erro == 'true') {
          this.alertCepIcon = 'mdi-alert'
          return
        } else this.alertCepIcon = ''

        let form = Object.assign({}, this.region ?? this.frmAddress)
        form.endereco.value = data.logradouro
        form.bairro.value = data.bairro
        form.estado.value = data.uf
        form.cidade.value = data.localidade

        if (this.region && this.region.cep.value != data.cep) {
          await this.setRegionTax(null)
        }

        form.cep.value = data.cep

        await this.setRegion(form)

        this.$nextTick()
      } catch (error) {
        this.$store.dispatch('updateSnackbar', {
          variant: 'error',
          message: error,
          show: true,
        })
      }
    },
  },
}
